module.exports = __webpack_public_path__ + "img/renewed.311bb813.svg";